import React from 'react';
import { Card, Row } from 'reactstrap';
import classnames from 'classnames';
import { Colxx } from '../../components/common/CustomBootstrap';
import Barcode from 'react-barcode';

class ComponentToPrint extends React.Component {
    componentWillUnmount() {
        document.body.classList.remove('noscroll');
    }

    render() {
        let {
            item
        } = this.props;

        return (
            <Row className='invoice-react w-100 invoice-contents' id='bill-to-print-tem'>
                <Colxx xxs='6'>
                    <Card
                        className={classnames('p-2  w-100', {
                            // card: !cardWrapper,
                        })}
                    >
                        {/* <CardBody className="p-2"> */}
                            <div className='d-flex flex-column align-items-center p-1 text-muted w-100'>
                                <Barcode 
                                    value={item.barcode} // Dữ liệu số cần mã hóa
                                    width={1.8}     // Độ rộng của mỗi vạch
                                    height={35}     // Chiều cao của mã vạch
                                    displayValue={true} // Có hiển thị dãy số bên dưới mã vạch hay không
                                    fontSize={14}   // Cỡ chữ của dãy số
                                    // margin={5}      // Khoảng cách lề
                                />
                                <p className='w-100'>{item.name} - {item.price} đ</p>
                            </div>
                        {/* </CardBody> */}
                    </Card>
                </Colxx>
            </Row>
        )
    }
}

export default ComponentToPrint;
